export default {
  header: {
    home: '首页',
    categories: '分类',
    about: '关于',
    searchPlaceholder: '搜索游戏...',
    toggleDarkMode: '切换暗黑模式',
    toggleLightMode: '切换明亮模式',
    changeLanguage: '切换语言'
  },
  nav: {
    home: '首页',
    categories: '分类',
    popular: '热门',
    favorites: '收藏',
    search: '搜索...',
    login: '登录',
    register: '注册',
    myProfile: '我的资料',
    settings: '设置',
    logout: '退出登录',
    darkMode: '暗黑模式',
    lightMode: '明亮模式',
    language: '语言',
    about: '关于'
  },
  footer: {
    about: '关于我们',
    contact: '联系我们',
    contactUs: '联系我们',
    policy: '隐私政策',
    terms: '使用条款',
    copyright: '© {year} GoGameVault. 保留所有权利。',
    playOnline: '在线游戏',
    bestGames: '最佳游戏',
    newGames: '新游戏',
    popularGames: '热门游戏',
    followUs: '关注我们',
    disclaimer: '所有游戏归原创者所有，本站不声称拥有任何相关权利。',
    introText: '最好的在线免费游戏平台。无需下载，无需注册，只有乐趣！',
    quickLinks: '快速链接',
    popularCategories: '热门分类',
    contactText: '有疑问、建议或反馈？我们很乐意听到您的声音！',
    aboutUs: '关于我们'
  },
  gameCard: {
    play: '开始游戏',
    new: '新游戏',
    popular: '热门'
  },
  shareButtons: {
    share: '分享',
    copyLink: '复制链接',
    facebook: '分享到Facebook',
    twitter: '分享到Twitter',
    whatsapp: '分享到WhatsApp',
    telegram: '分享到Telegram',
    copied: '已复制！'
  },
  searchBar: {
    search: '搜索',
    placeholder: '查找你喜欢的游戏...'
  },
  share: {
    title: '分享',
    copy: '复制链接',
    copied: '已复制',
    instagramNotSupported: 'Instagram暂不支持直接分享链接'
  },
  defaultGameImage: {
    text: '游戏图片'
  }
}; 